import React, { useMemo, useCallback } from "react";
import {
  Dropdown,
  Option,
  OptionOnSelectData,
  SelectionEvents,
  makeStyles,
  tokens,
  useId,
} from "@fluentui/react-components";
import { Option as OptionType } from "../../../types/common";

const useStyles = makeStyles({
  dropdown: {
    width: "100%",
    minWidth: "0",
    "& > button": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      minWidth: "0",
    },
  },
});

interface DropdownFieldProps {
  placeholder?: string;
  options: OptionType[];
  selectedValue?: number | string;
  onSelect: (value: string) => void;
}

const DropdownField: React.FC<DropdownFieldProps> = ({
  options,
  selectedValue,
  onSelect,
  placeholder,
}) => {
  const styles = useStyles();
  const id = useId("truckrates-dropdown");

  const selectedOptions = useMemo(
    () => (selectedValue ? [selectedValue.toString()] : []),
    [selectedValue],
  );

  const selectedLabel = useMemo(
    () => options.find((opt) => opt.value === selectedValue)?.label || "",
    [options, selectedValue],
  );

  const handleOptionSelect = useCallback(
    (_event: SelectionEvents, data: OptionOnSelectData) =>
      onSelect(data.optionValue || ""),
    [onSelect],
  );

  return (
    <Dropdown
      id={id}
      className={styles.dropdown}
      placeholder={placeholder}
      selectedOptions={selectedOptions}
      value={selectedLabel}
      onOptionSelect={handleOptionSelect}
    >
      {options.map((option) => (
        <Option
          style={{
            color: option.disabled ? tokens.colorNeutralForeground2 : "",
            backgroundColor: option.disabled
              ? tokens.colorNeutralBackground2
              : "",
            cursor: option.disabled ? "not-allowed" : "pointer",
          }}
          key={option.value.toString()}
          value={option.value.toString()}
          disabled={option.disabled}
        >
          {option.label}
        </Option>
      ))}
    </Dropdown>
  );
};

export default React.memo(DropdownField);
